import React, { forwardRef } from "react";
import { Link } from "react-router-dom";
import { CSSTransition } from "react-transition-group";

import {
  callToLearnMoreButtonClicked,
  contactUsButtonClicked,
} from "utils/segment";

import Portal from "./Portal";
import Container from "./Container";
import Row from "./Row";
import Col from "./Col";
import Button from "./Button";

const NavbarMenu = forwardRef(({ toggleMenu, menuCollapsed }, ref) => {
  function NavmenuLink(props) {
    return (
      <Link className="navbar-menu__link" to={props.to} onClick={toggleMenu}>
        {props.children}
      </Link>
    );
  }

  return (
    <CSSTransition
      in={!menuCollapsed}
      timeout={200}
      classNames="navbar"
      mountOnEnter
      unmountOnExit
      appear={true}
    >
      <Portal>
        <div className="navbar-menu" ref={ref}>
          <Container>
            <Row>
              <Col md={7}>
                <NavmenuLink to="/">Home</NavmenuLink>
                <NavmenuLink to="/about-papa-team">About Us</NavmenuLink>
                <NavmenuLink to="/pals/signup">Papa Pals</NavmenuLink>

                <hr />

                <NavmenuLink to="/health-plans">Health Plans</NavmenuLink>
                <NavmenuLink to="/employer-benefits">
                  Employer Benefits
                </NavmenuLink>
              </Col>

              <Col md={5} className="flex side">
                <div className="flex direction-column space-between">
                  <div className="section">
                    <p className="mb-20">Contact us for more info</p>

                    <Button
                      className="mb-10"
                      to="/contact-us"
                      onClick={() => {
                        contactUsButtonClicked({
                          buttonCta: "Contact Us",
                          descriptionText: undefined,
                          siteDivName: "NavbarMenu",
                        });
                      }}
                    >
                      Contact us
                    </Button>

                  </div>

                  <div>
                    <p className="mb-20">
                      Get started with using Papa, give us a call and see how we
                      can help.
                    </p>

                    <div className="hidden-desktop text-center text-uppercase font-600 mb-10">
                      Call to learn more
                    </div>
                    <Button
                      href="tel:+1-800-348-7951"
                      onClick={callToLearnMoreButtonClicked}
                    >
                      <span className="hidden-mobile">Call to learn more</span>{" "}
                      1-800-348-7951
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </Portal>
    </CSSTransition>
  );
});

export default NavbarMenu;
